var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100",attrs:{"id":"app"}},[_c('transition',[_c(_vm.component,{tag:"component"})],1),_c('PopUpComponent'),_c('ModalRatingComponent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }